import {
  RECAPTCHA_BADGE_BODY_CLASS,
  RECAPTCHA_BADGE_CLASS,
} from "~/modules/recaptcha/variables";

export function useRecaptchaDisplayControl() {
  function updateRecaptchaDisplay() {
    document.body.classList.toggle(RECAPTCHA_BADGE_BODY_CLASS);
  }

  function checkMountedRecaptcha() {
    return document.querySelector(RECAPTCHA_BADGE_CLASS) !== null;
  }

  return {
    updateRecaptchaDisplay,
    checkMountedRecaptcha,
  };
}
